import request from '@/utils/http'

const PREFIX = '/project'

const project = {
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  show(id) {
    return request(
      `${PREFIX}/${id}`,
      'get'
    )
  },

  page(params) {
    return request(
      `${PREFIX}`,
      'get',
      params
    )
  },

  list() {
    return request(
      `${PREFIX}/list`,
      'get',
    )
  },

  orgList() {
    return request(
      `${PREFIX}/orgList`,
      'get'
    )
  },

  orgListById(id) {
    return request(
      `${PREFIX}/orgList/${id}`,
      'get'
    )
  },

  userList() {
    return request(
      `${PREFIX}/userList`,
      'get'
    )
  },

  userTenantProjects(param) {
    return request(
      `${PREFIX}/userTenantProjects`,
      'get',
      param
    )
  },

  pageUserTenantProjects(params) {
    return request(
      `${PREFIX}/page/userTenantProjects`,
      'get',
      params
    )
  },

  getProjectUsers(id) {
    return request(
      `${PREFIX}/projectUsers/${id}`,
      'get'
    )
  },
  pageUserProjects(param) {
    return request(
      `${PREFIX}/page/userProjects`,
      'get',
      param
    )
  },
  changeStar(param) {
    return request(
      `${PREFIX}/userProject/star`,
      'put',
      param
    )
  },
  changeShow(param) {
    return request(
      `${PREFIX}/userProject/isShow`,
      'put',
      param
    )
  }
}

export default project
